// Application-wide client metadata. Keep this module independent from any page
// so authentication, navigation, dashboards, and reports share one source of truth.
import CMIGLogo from "../assets/logos/CMIG.svg";
import PMICLogo from "../assets/logos/PMIC.png";
import PEELLogo from "../assets/logos/PEEL.png";
import BCAALogo from "../assets/logos/BCAA.png";
import SGILogo from "../assets/logos/sgi.svg";

export const CLIENT_ORDER = Object.freeze(["CMIG", "PMIC", "PEEL", "BCAA", "SGI"]);

export const CLIENT_NAMES = Object.freeze({
  CMIG: "Commonwell Mutual",
  PMIC: "Portage Mutual",
  PEEL: "Peel Mutual",
  BCAA: "BCAA Insurance",
  SGI: "SGI Canada",
});

export const CLIENT_COLORS = Object.freeze({
  CMIG: "#ED8B00", // Deloitte Amber
  PEEL: "#75787B", // Deloitte Muted Gray
  PMIC: "#DA291C", // Deloitte Red
  BCAA: "#53565A", // Deloitte Dark Gray
  SGI: "#86BC25",  // Deloitte Green
});

export const CLIENT_LOGOS = Object.freeze({
  CMIG: CMIGLogo,
  PMIC: PMICLogo,
  PEEL: PEELLogo,
  BCAA: BCAALogo,
  SGI: SGILogo,
});

// JIRA project-key mapping (matches backend KEY_PREFIX_MAP in config.py).
export const PROJECT_KEYS = Object.freeze({
  SGI: "GWS",
  CMIG: "CMIG",
  PEEL: "ICPL",
  PMIC: "ICPO",
  BCAA: "BCAA",
});
